import { SelectedFilters, useFilters } from '../providers/FiltersProvider';
import { CashMovementActivityTypeFilter, RequestType, TabValue } from '../constants/request';
import { RequestQuery } from '../types/request';
import { Option } from 'neon-design-system';
import { useMemo } from 'react';
import { endOfDay, startOfDay } from 'date-fns';
import { useUpBreakpoints } from '../providers/BreakpointsProvider';

export const useRequestFilters = (
    filterName?: keyof SelectedFilters
): { requestQuery: RequestQuery | undefined } => {
    const { filters } = useFilters();
    const { md } = useUpBreakpoints();
    const isMobile = !md;

    const requestQuery = useMemo(() => {
        if (!filterName) return undefined;

        const { ranges, requestStatus, selectedAccounts, tab, activityType } = filters[
            filterName
        ] as any;
        const status = (requestStatus as any) === RequestType.ALL ? undefined : requestStatus;

        if (isMobile) {
            return {
                selectedAccounts:
                    (selectedAccounts?.map((option: Option) => option.value) as string[]) || []
            };
        }

        if (tab === TabValue.LATEST) {
            return {};
        }

        return {
            onlyUserRequests: filters[filterName].requestType === RequestType.MY_REQUESTS,
            statuses: [status].filter(Boolean) as string[],
            dateRange: {
                startDate: startOfDay(new Date(ranges?.[0]?.startDate!)),
                endDate: endOfDay(new Date(ranges?.[0]?.endDate!))
            },
            selectedAccounts:
                (selectedAccounts?.map((option: Option) => option.value) as string[]) || [],
            activityTypes:
                activityType === CashMovementActivityTypeFilter.ALL || !activityType
                    ? undefined
                    : [activityType]
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterName, filters]);

    return { requestQuery };
};
